
import React from "react";
import { Card } from "@/components/ui/card";
import { Mail, Phone, MapPin } from "lucide-react";

const ContactInfo: React.FC = () => {
  return (
    <Card className="p-6 bg-gradient-to-br from-white to-slate-50/40 border border-slate-200/60 shadow-sm animate-fade-in mb-8">
      <div className="flex items-center mb-6">
        <Mail className="h-6 w-6 text-primary mr-3" />
        <h2 className="text-2xl font-bold text-slate-800">Kontaktdaten</h2>
      </div>
      <div className="space-y-4">
        <div className="flex items-start">
          <Mail className="h-5 w-5 text-primary mt-1 mr-3" />
          <div>
            <p className="font-medium text-slate-700">E-Mail</p>
            <a href="mailto:info@joerg-hoermann.de" className="text-primary hover:underline">
              info@joerg-hoermann.de
            </a>
          </div>
        </div>
        <div className="flex items-start">
          <Phone className="h-5 w-5 text-primary mt-1 mr-3" />
          <div>
            <p className="font-medium text-slate-700">Telefon</p>
            <a href="tel:+4991719892118" className="text-slate-600">
              09171-9892118
            </a>
          </div>
        </div>
        <div className="flex items-start">
          <MapPin className="h-5 w-5 text-primary mt-1 mr-3" />
          <div>
            <p className="font-medium text-slate-700">Adresse</p>
            <p className="text-slate-600">
              Grimmstr. 15<br />
              91154 Roth
            </p>
          </div>
        </div>
      </div>
    </Card>
  );
};

export default ContactInfo;
